import { inject, Injectable } from '@angular/core';
import { BaseProcessor } from '../../base.processor';
import { FormFieldModel, FormModel } from '@alfresco/adf-core';
import { MasterarbeitsanmeldungVariables } from '../masterarbeitsanmeldung.variables';
import { BpmService } from '@alf-nx-workspace/shared/utils';
import { CheckUserProcessAlreadyExists } from '../masterarbeitsanmeldung.validators';

@Injectable({ providedIn: 'root' })
export class MasterarbeitsanmeldungStartFormularProcessor extends BaseProcessor {
  static FORM_NAME = 'masterarbeitsanmeldung';
  public readonly FORM_NAME = MasterarbeitsanmeldungStartFormularProcessor.FORM_NAME;

  private bpmService: BpmService = inject(BpmService);

  onLoaded(form: FormModel) {
    super.onLoaded(form);
    this.addFormFieldValidator(new CheckUserProcessAlreadyExists());
  }

  onFieldValueChange(field: FormFieldModel): void {
    if (field.id === MasterarbeitsanmeldungVariables.studium) {
      this.bpmService.checkUserProcessAlreadyExists(field.value).subscribe((exists) => {
        field.params[CheckUserProcessAlreadyExists.USER_PROCESS_ALREADY_EXISTS] = exists;
        (<FormModel>field.form).validateField(field);
      });
    }
  }
}
